const CustomizeIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.66667 5.00033C7.58714 5.00033 8.33333 4.25413 8.33333 3.33366C8.33333 2.41318 7.58714 1.66699 6.66667 1.66699C5.74619 1.66699 5 2.41318 5 3.33366C5 4.25413 5.74619 5.00033 6.66667 5.00033Z"
        fill="#ABBACC"
      />
      <path
        d="M6.66667 11.6663C7.58714 11.6663 8.33333 10.9201 8.33333 9.99967C8.33333 9.0792 7.58714 8.33301 6.66667 8.33301C5.74619 8.33301 5 9.0792 5 9.99967C5 10.9201 5.74619 11.6663 6.66667 11.6663Z"
        fill="#ABBACC"
      />
      <path
        d="M6.66667 18.3333C7.58714 18.3333 8.33333 17.5871 8.33333 16.6667C8.33333 15.7462 7.58714 15 6.66667 15C5.74619 15 5 15.7462 5 16.6667C5 17.5871 5.74619 18.3333 6.66667 18.3333Z"
        fill="#ABBACC"
      />
      <path
        d="M13.3334 5.00033C14.2539 5.00033 15.0001 4.25413 15.0001 3.33366C15.0001 2.41318 14.2539 1.66699 13.3334 1.66699C12.4129 1.66699 11.6667 2.41318 11.6667 3.33366C11.6667 4.25413 12.4129 5.00033 13.3334 5.00033Z"
        fill="#ABBACC"
      />
      <path
        d="M13.3334 11.6663C14.2539 11.6663 15.0001 10.9201 15.0001 9.99967C15.0001 9.0792 14.2539 8.33301 13.3334 8.33301C12.4129 8.33301 11.6667 9.0792 11.6667 9.99967C11.6667 10.9201 12.4129 11.6663 13.3334 11.6663Z"
        fill="#ABBACC"
      />
      <path
        d="M13.3334 18.3333C14.2539 18.3333 15.0001 17.5871 15.0001 16.6667C15.0001 15.7462 14.2539 15 13.3334 15C12.4129 15 11.6667 15.7462 11.6667 16.6667C11.6667 17.5871 12.4129 18.3333 13.3334 18.3333Z"
        fill="#ABBACC"
      />
    </svg>
  );
};

export default CustomizeIcon;
